import request from "@utils/request";
import qs from "qs";

/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function login(data) {
  return request.post(
    "/a/authc",
    qs.stringify({ username: data.account, password: data.password }),
    { login: false }
  );
}

/**
 * 用户手机号登录
 * @param data object 用户手机号 也只能
 */
export function loginMobile(data) {
  return request.post("/wap/login/mobile", qs.stringify(data), {
    login: false
  });
}

/**
 * 用户发送验证码
 * @param data object 用户手机号
 */
export function registerVerify(data) {
  return request.post("/wap/register/verify", qs.stringify(data), {
    login: false
  });
}

/**
 * 用户手机号注册
 * @param data object 用户手机号 验证码 密码
 */
export function register(data) {
  return request.post("/wap/register", qs.stringify(data), { login: false });
}

/**
 * 用户手机号修改密码
 * @param data object 用户手机号 验证码 密码
 */
export function registerReset(data) {
  return request.post("/wap/pwd/reset", qs.stringify(data), { login: false });
}

/*
 * 个人中心
 * */
export function getUser() {
  return request.get("/wap/user/info");
}
/*
 * 个人数据
 * */
export function getUserData() {
  return request.get("/wap/user/data");
}

/*
 * 用户信息
 * */
export function getUserInfo() {
  return request.get("/wap/userinfo");
}

/*
 * 个人中心(功能列表)
 * */
export function getMenuUser() {
  return request.get("/wap/user/menu");
}

/*
 * 获取收藏产品
 * */
export function getCollectUser(page, limit) {
  return request.get("/wap/collect/user", { page: page, limit: limit });
}

/*
 * 删除收藏产品
 * */
export function getCollectDel(id) {
  return request.post("/wap/collect/del/"+id);
}

/*
 * 批量收藏产品
 * */
export function postCollectAll(data) {
  return request.post("/collect/all", data);
}

/*
 * 添加收藏产品
 * */
export function collectAdd(id) {
  return request.post("/wap/collect/add/"+id);
}

/*
 * 查询收藏产品
 * */
export function getUserCollect(id) {
  return request.post("/wap/collect/user/"+id,{ login: true });
}

/*
 * 签到配置
 * */
export function getSignConfig() {
  return request.get("/wap/sign/config");
}

/*
 * 签到里的签到列表
 * */
export function getSignList(page, limit) {
  return request.get("/wap/sign/list", { pageNO: page, pageSize: limit });
}

/*
 * 签到列表
 * */
export function getSignMonth(page, limit) {
  return request.get("/wap/sign/month", { pageNO: page, pageSize: limit });
}

/*
 * 签到用户信息
 * */
export function postSignUser(sign) {
  return request.get("/wap/sign/user", sign);
}

/*
 * 签到
 * */
export function postSignIntegral(sign) {
  return request.post("/wap/sign/integral", sign);
}

/*
 * 推广数据
 * */
export function getSpreadInfo() {
  return request.get("/commission");
}

/*
 * 推广人列表
 * */
export function getSpreadUser(page) {
  return request.post("/wap/spread/people", page);
}

/*
 * 推广人订单
 * */
export function getSpreadOrder(where) {
  return request.post("/wap/spread/order", where);
}

/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getCommissionInfo(q, types) {
  return request.post("/wap/spread/commission/" + types, q);
}

/*
 * 积分记录
 * */
export function getIntegralList(q) {
  return request.get("/wap/integral/list", { pageNO: q.page, pageSize: q.limit });
}

/*
 * 积分统计
 * */
export function getIntegralUser() {
  return request.get("/wap/integral/user");
}

/*
 * 提现银行
 * */
export function getBank() {
  return request.get("/extract/bank");
}

/*
 * 提现申请
 * */
export function postCashInfo(cash) {
  return request.post("/extract/cash", cash);
}

/*
 * 会员中心
 * */
export function getVipInfo() {
  return request.post("/wap/grade");
}

/*
 * 会员等级任务
 * */
export function getVipTask(id) {
  return request.post("/wap/user/level/task/" + id);
}

/*
 * 会员等级任务
 * */
export function getUserVipInfo() {
  return request.post("/wap/user/level");
}

/*
 * 资金统计
 * */
export function getBalance() {
  return request.get("/user/balance");
}

/*
 * 活动状态
 * */
export function getActivityStatus() {
  return request.get("/user/activity", {}, { login: false });
}

/*
 * 活动状态
 * */
export function getSpreadImg() {
  return request.get("/wap/spread/banner");
}

/*
 * 用户修改信息
 * */
export function postUserEdit(data) {
  return request.post("/wap/user/edit", qs.stringify(data));
}

/*
 * 用户修改信息
 * */
export function getChatRecord(to_uid, data) {
  return request.get("user/service/record/" + to_uid, data);
}

/*
 * 用户修改信息
 * */
export function serviceList() {
  return request.get("user/service/list");
}

/*
 * 公众号充值
 * */
export function rechargeWechat(data) {
  return request.post("/recharge/wechat", data);
}

/*
 * 退出登录
 * */
export function getLogout() {
  return request.get("/logout");
}

/*
 * 绑定手机号
 * */
export function bindingPhone(data) {
  return request.post("/wap/user/bind", qs.stringify(data));
}

/*
 * h5切换公众号登陆
 * */
export function switchH5Login() {
  return request.post("switch_h5", { from: "wechat" });
}
/*
 * 获取推广人排行
 * */
export function getRankList(q) {
  return request.post("/wap/spread/rank", q);
}
/*
 * 获取佣金排名
 * */
export function getBrokerageRank(q) {
  return request.post("/wap/spread/brokerage/rank", q);
}
/**
 * 检测会员等级
 */
export function setDetection() {
  return request.get("user/level/detection");
}
/**
 * 获取推广人信息
 */
export function getSpreadAccount() {
  return request.post("/wap/spread/get");
}
